import React, { useState } from 'react';
import Icon from 'components/AppIcon';

const AUDIT_LOGS = [
  { id: 1, action: 'Usuario activado', target: 'María González', admin: 'Carlos Rodríguez', timestamp: '05/03/2026 22:45', type: 'activate' },
  { id: 2, action: 'Rol modificado', target: 'Pedro Martínez → OPERATOR', admin: 'Carlos Rodríguez', timestamp: '05/03/2026 21:30', type: 'role' },
  { id: 3, action: 'Usuario suspendido', target: 'Luis Herrera', admin: 'Ana López', timestamp: '05/03/2026 19:15', type: 'suspend' },
  { id: 4, action: 'Contraseña restablecida', target: 'Sandra Vargas', admin: 'Carlos Rodríguez', timestamp: '05/03/2026 17:00', type: 'password' },
  { id: 5, action: 'Usuario rechazado', target: 'Empresa XYZ S.A.S.', admin: 'Ana López', timestamp: '04/03/2026 16:20', type: 'reject' },
  { id: 6, action: 'Usuario reactivado', target: 'Jorge Ramírez', admin: 'Carlos Rodríguez', timestamp: '04/03/2026 14:10', type: 'reactivate' },
  { id: 7, action: 'Usuario activado', target: 'Claudia Moreno', admin: 'Ana López', timestamp: '04/03/2026 11:05', type: 'activate' },
];

const TYPE_CONFIG = {
  activate: { icon: 'CheckCircle', color: '#059669', bg: 'bg-emerald-100' },
  role: { icon: 'Shield', color: '#7C3AED', bg: 'bg-purple-100' },
  suspend: { icon: 'UserX', color: '#DC2626', bg: 'bg-red-100' },
  password: { icon: 'Key', color: '#D97706', bg: 'bg-amber-100' },
  reject: { icon: 'XCircle', color: '#DC2626', bg: 'bg-red-100' },
  reactivate: { icon: 'UserCheck', color: '#0891B2', bg: 'bg-cyan-100' },
};

const AuditLogPanel = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
      <button
        onClick={() => setIsOpen(v => !v)}
        className="w-full flex items-center justify-between px-5 py-4 hover:bg-gray-50 transition-colors"
      >
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8 rounded-lg bg-blue-100 flex items-center justify-center">
            <Icon name="ClipboardList" size={16} color="#0891B2" />
          </div>
          <div className="text-left">
            <p className="text-sm font-semibold text-gray-800 font-heading">Registro de Auditoría</p>
            <p className="text-xs text-gray-500 font-caption">Últimas acciones administrativas</p>
          </div>
        </div>
        <Icon name={isOpen ? 'ChevronUp' : 'ChevronDown'} size={16} color="#9CA3AF" />
      </button>
      {isOpen && (
        <div className="border-t border-gray-100 divide-y divide-gray-50 max-h-80 overflow-y-auto scrollbar-thin">
          {AUDIT_LOGS?.map(log => {
            const cfg = TYPE_CONFIG?.[log?.type] || TYPE_CONFIG?.activate;
            return (
              <div key={log?.id} className="flex items-start gap-3 px-5 py-3 hover:bg-gray-50 transition-colors">
                <div className={`w-7 h-7 rounded-lg ${cfg?.bg} flex items-center justify-center flex-shrink-0 mt-0.5`}>
                  <Icon name={cfg?.icon} size={13} color={cfg?.color} />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-xs font-semibold text-gray-700 font-caption">{log?.action}</p>
                  <p className="text-xs text-gray-500 font-caption truncate">{log?.target}</p>
                  <p className="text-xs text-gray-400 font-caption">Por: {log?.admin} · {log?.timestamp}</p>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default AuditLogPanel;